var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"user-action-btn",attrs:{"type":"button","title":"Удалить пользователя","disabled":_vm.user.role === 'Главный Администратор'},on:{"click":_vm.openConfirmModal}},[_c('ico',{attrs:{"name":"icoDelete","color":"#79919C"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }